import React, { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="topbar">
        <div className="wrap">
          <div className="left">
            <a href="tel:+919058585894">📞 +91 90585 85894</a>
            <a href="mailto:support@infinityresearchwork.com">
              ✉️ support@infinityresearchwork.com
            </a>
            <span>Mon–Sat, 10 AM – 7 PM IST</span>
          </div>
          <div className="right">
            <span>🌐 15,000+ Scholars Guided</span>
            <span>🎉 30% OFF — Limited Time</span>
          </div>
        </div>
      </div>

      <header className="site">
        <div className="nav wrap">
          <a href="#top" className="logo">
            <span className="mark">IR</span> Infinity Research Work
          </a>
          <nav className={`links ${open ? "open" : ""}`}>
            <a href="#top" onClick={() => setOpen(false)}>Home</a>
            <a href="#services" onClick={() => setOpen(false)}>Services</a>
            <a href="#about" onClick={() => setOpen(false)}>About</a>
            <a href="#process" onClick={() => setOpen(false)}>How It Works</a>
            <a href="#reviews" onClick={() => setOpen(false)}>Reviews</a>
            <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
            <a
              className="btn btn-whatsapp"
              href="https://wa.me/919058585894"
              target="_blank"
              rel="noopener noreferrer"
            >
              💬 WhatsApp
            </a>
          </nav>
          <button
            className="menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
          >
            ☰
          </button>
        </div>
      </header>
    </>
  );
}
